import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InfoDeviceState {
  id: any;
  name: any;
  deviceTypeId: any;
  deviceType: any;
  model: any;
  pieces: any;
  props: {
    [key: string]: any;
  };
}

const initialState: InfoDeviceState = {
  id: '',
  name: '',
  deviceTypeId: '',
  deviceType: null,
  model: '',
  pieces: '',
  props: { isModalVisible: false, refresh: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const infoDeviceSlice = createSlice({
  name: 'infoDevice',
  initialState,
  reducers: {
    setInfoDevice: (state, action: PayloadAction<Partial<InfoDeviceState>>) => {
      return { ...state, ...action.payload };
    },

    resetInfoDevice: (_state, action: PayloadAction<Partial<InfoDeviceState['props']> | undefined>) => {
      return {
        ...initialState,
        props: { ...initialState.props, ...action.payload },
      };
    },

    updateField: (state: InfoDeviceState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },
  },
});

export const { setInfoDevice, resetInfoDevice, updateField, updateProps } = infoDeviceSlice.actions;

export default infoDeviceSlice.reducer;
